export default {"src":"/_next/static/media/gray-bath.c9f482f9.svg","height":2893,"width":4953,"blurWidth":0,"blurHeight":0};